/* eslint-disable @typescript-eslint/no-unused-vars */
import { ChangeDetectorRef, Directive, Inject, Optional } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { de, enGB, enUS, fr, kk, ru, tr } from 'date-fns/locale';

@Directive()
export class CustomDateAdapter extends DateFnsAdapter {
    _format: string;
    constructor(
        @Optional()
        @Inject(MAT_DATE_LOCALE)
        public dateLocale: any,
        public translateService: TranslateService,
        private cdr: ChangeDetectorRef
    ) {
        super(dateLocale);
        this.setDateFnsLocale(this.translateService.currentLang);
        this.translateService.onLangChange.pipe(takeUntilDestroyed()).subscribe(event => {
            this.setDateFnsLocale(event.lang);
            this.cdr.markForCheck();
        });
    }

    setDateFnsLocale(locale: string) {
        switch (locale) {
            case 'en':
                this.setLocale(enGB);
                break;
            case 'en-us':
                this.setLocale(enUS);
                break;
            case 'de':
                this.setLocale(de);
                break;
            case 'fr':
                this.setLocale(fr);
                break;
            case 'ru':
                this.setLocale(ru);
                break;
            case 'kk':
                this.setLocale(kk);
                break;
            case 'tr':
                this.setLocale(tr);
                break;
            default:
                this.setLocale(enUS);
                break;
        }
    }

    getFirstDayOfWeek(): number {
        return 1;
    }

    getDayOfWeekNames(_style: 'long' | 'short' | 'narrow'): string[] {
        return super.getDayOfWeekNames('short');
    }
}
